// extracted by mini-css-extract-plugin
export default {"text-row-container":"TextRowComponent_text-row-container__3YBDy","text-columns":"TextRowComponent_text-columns__pRDar","column-number":"TextRowComponent_column-number__O9uxb"};